// Korean translations (한국어)
export const ko: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': '로딩 중...',
  'common.error': '오류가 발생했습니다',
  'common.retry': '다시 시도',
  'common.cancel': '취소',
  'common.save': '저장',
  'common.continue': '계속',
  'common.back': '뒤로',
  'common.next': '다음',
  'common.skip': '건너뛰기',
  'common.done': '완료',
  'common.yes': '예',
  'common.no': '아니오',
  'common.ok': '확인',
  'common.check': '확인',
  'common.correct': '정답!',
  'common.incorrect': '오답',
  'common.tryAgain': '다시 시도',
  'common.start': '시작',
  'common.finish': '완료',
  'common.submit': '제출',

  // ==================== NAVIGATION ====================
  'nav.home': '홈',
  'nav.learn': '학습',
  'nav.courses': '코스',
  'nav.vocabulary': '단어장',
  'nav.profile': '프로필',
  'nav.settings': '설정',
  'nav.logout': '로그아웃',
  'nav.leaderboard': '리더보드',
  'nav.aiTutor': 'AI 튜터',
  'nav.culture': '문화',
  'nav.chat': '대화',
  'nav.ranking': '랭킹',
  'nav.family': '가족',
  'nav.premium': '프리미엄',

  // ==================== HOME PAGE ====================
  'home.greeting': '안녕하세요',
  'home.streak': '일 연속',
  'home.dailyGoal': '오늘의 목표',
  'home.myLanguages': '내 언어',
  'home.addLanguage': '언어 추가',
  'home.recommended': '추천',
  'home.continue': '이어서 학습하기',
  'home.selectLanguage': '언어를 선택하세요',
  'home.totalXp': '총 XP',
  'home.bestStreak': '최장 연속',
  'home.level': '레벨',

  // ==================== CHAT ====================
  'chat.aiTutor': 'AI 튜터',
  'chat.aiTutorDesc': 'AI와 대화 연습하기',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'SpeakFlow에 오신 것을 환영합니다!',
  'onboarding.welcome.subtitle': 'AI와 함께하는 언어 학습',
  'onboarding.selectLanguage': '언어를 선택하세요',
  'onboarding.selectLanguageDesc': '앱 인터페이스 언어를 선택하세요',
  'onboarding.selectUILanguage': '언어를 선택하세요',
  'onboarding.selectUILanguage.subtitle': '앱 인터페이스에 사용됩니다',
  'onboarding.selectLearningLanguage': '무엇을 배우고 싶으세요?',
  'onboarding.selectLearningLanguage.subtitle': '여러 언어를 선택할 수 있습니다',
  'onboarding.selectDailyGoal': '일일 목표를 설정하세요',
  'onboarding.selectDailyGoal.subtitle': '하루에 얼마나 학습할 수 있나요?',
  'onboarding.selectGoal': '학습 목표가 무엇인가요?',
  'onboarding.selectGoalDesc': '맞춤형 학습 경로를 제공해 드립니다',
  'onboarding.takeTest': '레벨 테스트 보기',
  'onboarding.takeTestDesc': '5분 안에 실력을 확인하세요',
  'onboarding.skipTest': '나중에 하기',
  'onboarding.skipTestDesc': '처음부터 시작하기',
  'onboarding.letsGo': '시작하기!',
  'onboarding.step': '단계',
  'onboarding.of': '/',
  'onboarding.ready': '준비 완료!',
  'onboarding.ready.subtitle': '언어 학습 여정을 시작해봐요',
  'onboarding.features.languages': '4개 언어',
  'onboarding.features.aiTutor': 'AI 튜터',
  'onboarding.features.dailyGoals': '일일 목표',

  // Daily Goal options
  'dailyGoal.5min': '5분',
  'dailyGoal.10min': '10분',
  'dailyGoal.15min': '15분',
  'dailyGoal.20min': '20분',
  'dailyGoal.casual': '가볍게',
  'dailyGoal.regular': '꾸준히',
  'dailyGoal.serious': '진지하게',
  'dailyGoal.intense': '집중적으로',

  // ==================== LEVEL TEST ====================
  'levelTest.title': '레벨 테스트',
  'levelTest.subtitle': '한국어 실력을 확인해 보세요',
  'levelTest.duration': '약 5분 소요',
  'levelTest.questions': '문제',
  'levelTest.vocabulary': '어휘',
  'levelTest.grammar': '문법',
  'levelTest.listening': '듣기',
  'levelTest.speaking': '말하기',
  'levelTest.analyzing': '결과 분석 중...',
  'levelTest.yourLevel': '당신의 레벨',
  'levelTest.congratulations': '축하합니다!',
  'levelTest.resultDesc': '테스트 결과에 따르면',
  'levelTest.startLearning': '학습 시작',
  'levelTest.retakeTest': '다시 테스트',
  'levelTest.sectionComplete': '섹션 완료',
  'levelTest.nextSection': '다음 섹션',
  'levelTest.listenAndAnswer': '듣고 답하세요',
  'levelTest.speakNow': '말해보세요',
  'levelTest.tapToListen': '탭해서 듣기',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': '입문',
  'cefr.A2': '초급',
  'cefr.B1': '중급',
  'cefr.B2': '중상급',
  'cefr.C1': '고급',
  'cefr.C2': '마스터',
  'cefr.A1.desc': '기본 인사와 간단한 표현',
  'cefr.A2.desc': '일상생활에 대한 간단한 대화',
  'cefr.B1.desc': '대부분의 여행 상황 대처 가능',
  'cefr.B2.desc': '원어민과 유창하게 대화 가능',
  'cefr.C1.desc': '아이디어를 유창하고 자연스럽게 표현',
  'cefr.C2.desc': '모든 상황에서 원어민 수준의 능숙함',

  // ==================== LEAGUE / RANKING ====================
  'league.title': '리그',
  'league.weeklyRanking': '주간 랭킹',
  'league.bronze': '브론즈',
  'league.silver': '실버',
  'league.gold': '골드',
  'league.platinum': '플래티넘',
  'league.diamond': '다이아몬드',
  'league.promotion': '승급권',
  'league.demotion': '강등권',
  'league.safe': '유지권',
  'league.weeklyXP': '주간 XP',
  'league.rank': '순위',
  'league.daysLeft': '일 남음',
  'league.promoted': '승급!',
  'league.demoted': '강등',
  'league.stayed': '유지',
  'league.noData': '아직 랭킹 데이터가 없습니다',
  'league.earnXP': 'XP를 획득해서 리그에 참가하세요!',
  'league.topPercent': '상위 {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': '#1 한국어 학습 앱',
  'landing.title': '한국어 배우기',
  'landing.titleAccent': '재미있게',
  'landing.subtitle': '짧은 레슨, 전통 문화 콘텐츠, AI 발음 피드백으로 한국어를 마스터하세요. 100만+ 학습자와 함께하세요!',
  'landing.getStarted': '무료로 시작하기',
  'landing.learnMore': '더 알아보기',
  'landing.login': '로그인',
  'landing.startFree': '무료 시작',
  'landing.learners': '학습자',
  'landing.lessons': '레슨',
  'landing.countries': '국가',

  // ==================== FEATURES ====================
  'features.title': '왜 KoreanFlow인가요?',
  'features.subtitle': '게이미피케이션, 실제 콘텐츠, AI 기술을 결합하여 한국어 학습을 재미있고 효과적으로 만듭니다.',
  'features.streaks.title': '연속 학습',
  'features.streaks.desc': '일일 목표와 연속 학습 보상으로 습관을 만드세요. XP와 보석으로 동기 부여!',
  'features.folksong.title': '민요',
  'features.folksong.desc': '전통 민요로 한국어를 배우세요. 가사와 문화를 이해하세요!',
  'features.culture.title': '한국 문화',
  'features.culture.desc': '속담, 유행어, 필수 표현을 탐험하세요. 진정한 표현을 마스터하세요.',
  'features.ai.title': 'AI 챗봇',
  'features.ai.desc': 'AI 튜터와 대화를 연습하세요. 즉각적인 피드백과 교정을 받으세요.',
  'features.leaderboard.title': '리더보드',
  'features.leaderboard.desc': '전 세계 학습자들과 경쟁하세요. 주간 랭킹에 도전하세요!',
  'features.srs.title': 'SRS 단어장',
  'features.srs.desc': '스마트 반복 시스템으로 배운 것을 영원히 기억하세요.',
  'features.pronunciation.title': '발음 피드백',
  'features.pronunciation.desc': 'AI 기반 발음 분석으로 상세한 점수를 받으세요.',

  // ==================== CTA ====================
  'cta.title': '여정을 시작할 준비가 되셨나요?',
  'cta.subtitle': '수백만 학습자와 함께 오늘 한국어를 시작하세요. 무료입니다!',
  'cta.button': '무료로 학습 시작',

  // ==================== AUTH ====================
  'auth.login': '로그인',
  'auth.register': '회원가입',
  'auth.email': '이메일',
  'auth.emailPlaceholder': '이메일을 입력하세요',
  'auth.password': '비밀번호',
  'auth.passwordPlaceholder': '비밀번호를 만드세요',
  'auth.confirmPassword': '비밀번호 확인',
  'auth.forgotPassword': '비밀번호를 잊으셨나요?',
  'auth.noAccount': '계정이 없으신가요?',
  'auth.haveAccount': '이미 계정이 있으신가요?',
  'auth.orContinueWith': '또는 다음으로 계속',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': '계정 만들기',
  'auth.createAccountTitle': '계정 만들기',
  'auth.createAccountSubtitle': '오늘 한국어 학습 여정을 시작하세요',
  'auth.username': '사용자 이름',
  'auth.usernamePlaceholder': '사용자 이름을 선택하세요',
  'auth.usernameHint': '문자, 숫자, 밑줄만 사용 가능',
  'auth.passwordHint': '대문자, 소문자, 숫자를 포함한 8자 이상',
  'auth.nativeLanguage': '모국어',
  'auth.nativeLanguageHint': '이 언어로 설명을 표시합니다',
  'auth.termsAgree': '가입하시면 다음에 동의하는 것입니다',
  'auth.terms': '이용약관',
  'auth.and': '및',
  'auth.privacyPolicy': '개인정보처리방침',
  'auth.loginTitle': '다시 오신 것을 환영합니다',
  'auth.loginSubtitle': '로그인하여 학습을 계속하세요',
  'auth.loginButton': '로그인',
  'auth.registerButton': '가입하기',
  'auth.rememberMe': '로그인 상태 유지',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': '다시 오신 것을 환영합니다',
  'dashboard.todayGoal': '오늘의 목표',
  'dashboard.streak': '연속 학습',
  'dashboard.days': '일',
  'dashboard.xp': 'XP',
  'dashboard.level': '레벨',
  'dashboard.continueLearning': '학습 계속하기',
  'dashboard.recommended': '추천 코스',
  'dashboard.myCourses': '내 코스',
  'dashboard.seeAll': '모두 보기',
  'dashboard.dailyGoalComplete': '일일 목표 달성!',
  'dashboard.keepGoing': '계속 힘내세요!',
  'dashboard.yourLevel': '현재 레벨',
  'dashboard.weeklyProgress': '주간 진행률',

  // ==================== COURSES ====================
  'courses.title': '전체 코스',
  'courses.search': '코스 검색...',
  'courses.all': '전체',
  'courses.beginner': '입문',
  'courses.elementary': '초급',
  'courses.intermediate': '중급',
  'courses.advanced': '고급',
  'courses.lessons': '레슨',
  'courses.enrolled': '수강 중',
  'courses.progress': '진행률',
  'courses.completed': '완료',
  'courses.recommended': '추천',
  'courses.forYourLevel': '레벨에 맞는 코스',
  'courses.locked': '잠김',
  'courses.unlockWith': '프리미엄으로 잠금 해제',

  // ==================== LESSON ====================
  'lesson.loading': '레슨 로딩 중...',
  'lesson.notFound': '레슨을 찾을 수 없습니다',
  'lesson.quit': '정말 종료하시겠습니까? 진행 상황이 저장되지 않습니다.',
  'lesson.complete': '레슨 완료!',
  'lesson.perfect': '완벽해요!',
  'lesson.amazing': '대단해요! 모두 맞혔습니다!',
  'lesson.xpEarned': '획득한 XP',
  'lesson.accuracy': '정확도',
  'lesson.correct': '정답',
  'lesson.goBack': '돌아가기',
  'lesson.skip': '건너뛰기',
  'lesson.unknownType': '알 수 없는 문제 유형',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': '탭하여 정답 보기',
  'exercise.matchPairs': '짝 맞추기',
  'exercise.matched': '개 맞춤',
  'exercise.arrangeWords': '단어 배열하기',
  'exercise.speak': '말하기',
  'exercise.listening': '듣는 중... 말해보세요!',
  'exercise.processing': '음성 처리 중...',
  'exercise.tapToSpeak': '탭하여 말하기',
  'exercise.cantSpeak': '지금 말할 수 없나요? 건너뛰기',
  'exercise.again': '다시',
  'exercise.gotIt': '알겠어요!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': '발음 연습',
  'pronunciation.subtitle': 'AI 피드백으로 한국어 발음을 향상시키세요',
  'pronunciation.selectLevel': '레벨 선택',
  'pronunciation.beginner': '입문',
  'pronunciation.intermediate': '중급',
  'pronunciation.advanced': '고급',
  'pronunciation.score': '점수',
  'pronunciation.accuracy': '정확도',
  'pronunciation.fluency': '유창성',
  'pronunciation.intonation': '억양',
  'pronunciation.feedback': '피드백',
  'pronunciation.tryAgain': '다시 시도',
  'pronunciation.next': '다음',
  'pronunciation.listen': '듣기',
  'pronunciation.slow': '천천히',
  'pronunciation.sessionComplete': '세션 완료!',
  'pronunciation.bestScore': '최고 점수',
  'pronunciation.average': '평균',
  'pronunciation.attempts': '시도 횟수',
  'pronunciation.practiceAgain': '다시 연습',
  'pronunciation.changeLevel': '레벨 변경',
  'pronunciation.tips': '더 나은 발음을 위한 팁',
  'pronunciation.tip1': '먼저 오디오를 들으세요',
  'pronunciation.tip2': '명확하고 일정한 속도로 말하세요',
  'pronunciation.tip3': '어려운 단어는 느린 재생을 사용하세요',
  'pronunciation.tip4': '조용한 환경에서 연습하세요',

  // ==================== VOCABULARY ====================
  'vocab.title': '단어장',
  'vocab.totalWords': '전체 단어',
  'vocab.mastered': '마스터',
  'vocab.dueToday': '오늘 복습',
  'vocab.reviewSession': '복습 세션',
  'vocab.wordsDue': '개 단어 복습 필요',
  'vocab.startReview': '복습 시작',
  'vocab.allCaughtUp': '모두 완료!',
  'vocab.noWordsDue': '복습할 단어가 없습니다',
  'vocab.sessionComplete': '세션 완료!',
  'vocab.allWords': '모든 단어',

  // ==================== LEARN PAGE ====================
  'learn.title': '학습',
  'learn.currentLevel': '현재 레벨',
  'learn.noCoursesYet': '준비 중!',
  'learn.noCoursesDescription': '이 언어의 코스를 준비하고 있습니다.',
  'learn.lessonsCompleted': '레슨 완료',
  'learn.startCourse': '코스 시작',
  'learn.continueCourse': '계속하기',
  'learn.courseCompleted': '완료됨',
  'learn.locked': '잠김',
  'learn.unlockBy': '이전 코스를 완료하면 잠금 해제',

  // ==================== COURSE PAGE ====================
  'course.progress': '진행률',
  'course.lessons': '레슨',
  'course.lessonsCompleted': '개 레슨 완료',
  'course.noLessons': '레슨을 준비 중입니다...',

  // ==================== LESSON PAGE ====================
  'lesson.tapToReveal': '탭하여 뜻 확인',
  'lesson.examples': '예문',
  'lesson.questionsCorrect': '정답',
  'lesson.wordsLearned': '단어',
  'lesson.grammarPoints': '문법',
  'lesson.backToCourse': '코스로 돌아가기',
  'lesson.practiceAgain': '다시 연습하기',
  'lesson.whatYouLearn': '배울 내용',
  'lesson.newWords': '개의 새 단어',
  'lesson.exercises': '개의 연습 문제',
  'lesson.startLesson': '레슨 시작',
  'lesson.reviewLesson': '레슨 복습',
  'lesson.learnVocabulary': '어휘 학습',
  'lesson.grammarPoint': '문법 포인트',
  'lesson.practice': '연습',

  // ==================== PROFILE ====================
  'profile.title': '프로필',
  'profile.level': '레벨',
  'profile.xpToNext': '다음 레벨까지',
  'profile.totalXp': '총 XP',
  'profile.currentStreak': '현재 연속 학습',
  'profile.lessonsDone': '완료한 레슨',
  'profile.timeLearned': '학습 시간',
  'profile.achievements': '업적',
  'profile.settings': '설정',
  'profile.dailyGoals': '일일 목표',
  'profile.allAchievements': '모든 업적',
  'profile.logOut': '로그아웃',
  'profile.koreanLevel': '한국어 레벨',
  'profile.guest': '게스트',
  'profile.days': '일',
  'profile.longestStreak': '최장',
  'profile.lessonsCompleted': '완료',
  'profile.dailyGoal': '일일 목표',
  'profile.learningLanguages': '학습 중인 언어',
  'profile.noLanguages': '선택된 언어가 없습니다',
  'profile.minutesPerDay': '분/일',
  'profile.learningHistory': '학습 기록',
  'profile.viewProgress': '진행 상황 보기',
  'profile.appSettings': '앱 설정',
  'profile.languageNotifications': '언어, 알림',
  'profile.loginToSave': '로그인하여 진행 상황 저장',

  // ==================== SETTINGS ====================
  'settings.title': '설정',
  'settings.language': '앱 언어',
  'settings.preferences': '환경설정',
  'settings.sound': '효과음',
  'settings.soundEffects': '효과음',
  'settings.soundEffectsDesc': '문제 풀 때 효과음 재생',
  'settings.notifications': '알림',
  'settings.notificationsDesc': '매일 학습 알림 받기',
  'settings.darkMode': '다크 모드',
  'settings.darkModeDesc': '편안한 보기를 위한 어두운 테마',
  'settings.dailyReminder': '일일 알림',
  'settings.account': '계정',
  'settings.editProfile': '프로필 편집',
  'settings.terms': '이용약관',
  'settings.privacy': '개인정보처리방침',
  'settings.help': '도움말',
  'settings.about': '정보',
  'settings.retakeTest': '레벨 테스트 다시 보기',
  'settings.retakeTestDesc': '현재 한국어 실력을 확인하세요',
  'settings.learning': '학습',
  'settings.dailyGoal': '일일 목표',
  'settings.minutesPerDay': '분/일',
  'settings.selectLanguage': '언어 선택',
  'settings.selectDailyGoal': '일일 목표 설정',
  'settings.perDay': '/일',
  'settings.appInfo': '앱 정보',
  'settings.logout': '로그아웃',

  // ==================== FOOTER ====================
  'footer.privacy': '개인정보',
  'footer.terms': '이용약관',
  'footer.contact': '문의',
  'footer.rights': '모든 권리 보유.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': '쿠키 사용 안내',
  'cookie.description': '저희는 경험 개선, 사이트 트래픽 분석, 콘텐츠 개인화를 위해 쿠키를 사용합니다. 필수가 아닌 쿠키를 수락하거나 거부할 수 있습니다.',
  'cookie.learnMore': '자세히 알아보기',
  'cookie.acceptAll': '모두 수락',
  'cookie.rejectAll': '모두 거부',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': '단어장',
  'quickAction.reviewWords': '단어 복습',
  'quickAction.allCourses': '전체 코스',
  'quickAction.browseLessons': '레슨 둘러보기',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': '코스를 찾을 수 없습니다',
  'courseDetail.lessons': '레슨',
  'courseDetail.completed': '완료',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': '홈',
  'bottomNav.courses': '코스',
  'bottomNav.vocab': '단어',
  'bottomNav.profile': '프로필',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'AI 튜터',
  'aiTutor.selectScenario': '시나리오 선택',
  'aiTutor.freeTalk': '자유 대화',
  'aiTutor.cafe': '카페 주문',
  'aiTutor.shopping': '쇼핑',
  'aiTutor.restaurant': '식당',
  'aiTutor.friends': '친구 사귀기',
  'aiTutor.interview': '취업 면접',
  'aiTutor.typeMessage': '메시지를 입력하세요...',
  'aiTutor.send': '보내기',

  // ==================== ERRORS ====================
  'error.generic': '문제가 발생했습니다',
  'error.network': '네트워크 오류입니다. 연결을 확인해주세요.',
  'error.notFound': '페이지를 찾을 수 없습니다',
  'error.unauthorized': '계속하려면 로그인해주세요',
  'error.microphoneAccess': '마이크 접근이 거부되었습니다',
  'error.speechNotSupported': '음성 인식이 지원되지 않습니다. Chrome 브라우저를 사용해보세요.',
};

export default ko;
